import Dashboard from "./HOC/Dashboard";
import { Switch, Route, Redirect } from "react-router-dom";
import "./assets/scss/main.scss";
import Header from "./components/Header";

function App() {
  return (
    <div className="App ">
      <Header />

      <Switch>
        <Route exact path="/raw-tx">
          <Dashboard />
        </Route>

        <Route exact path="/">
          <Redirect to="/raw-tx" />
        </Route>

        {/* Catch all other routes and redirect */}
        <Route path="*">
          <Redirect to="/raw-tx" />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
